"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function createFilterId() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat((0, _lodash.kebabCase)(name), "-filter");
}
var _default = exports["default"] = createFilterId;